"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
export default function Hero() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.1,
        delayChildren: 0.05
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="hero" data-nav="light" className="relative bg-background text-foreground pt-28 pb-16 sm:pt-36 sm:pb-20 lg:pt-40 lg:pb-24 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="mx-auto max-w-3xl text-center">
          {/* Category Eyebrow Badge */}
          <motion.div variants={itemVariants} className="flex justify-center mb-5">
            <Badge variant="outline" className="border-chart-1/30 bg-chart-1/10 text-chart-1 px-3.5 py-1 text-xs font-semibold tracking-wider uppercase font-sans rounded-full">
              Decatur Remodeling Journal
            </Badge>
          </motion.div>

          {/* Main Display Heading */}
          <motion.h1 variants={itemVariants} className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground tracking-tight leading-[1.15]">
            Remodeling Insights &amp; Guides
          </motion.h1>

          {/* Introductory Body Copy */}
          <motion.p variants={itemVariants} className="mt-6 text-base sm:text-lg md:text-xl text-muted-foreground font-sans leading-relaxed max-w-2xl mx-auto">
            Practical renovation advice, neighborhood cost breakdowns, and planning guidance for historic craftsman homes, mid-century ranches, and modern additions across Decatur.
          </motion.p>

          {/* Architectural Copper Hairline Divider */}
          <motion.div variants={itemVariants} className="pt-2">
            <div role="separator" aria-hidden="true" className="h-[2px] w-24 bg-chart-1 mx-auto mt-6 rounded-full" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}